import PeriodLockView from '@/period-lock/PeriodLockView.vue'
import {registerRoute} from '@/router'
import {useContaCommand} from '@/commandbar/commandBar.service'
import {NavGroup, registerNavigationEntry} from '@/navigation'
import {useBreadCrumbs} from '@/breadcrumbs/useBreadCrumbs'
import {PanelContent} from '@tritt/multipanel'

const {registerNavigationCommand} = useContaCommand()
const {buildSimpleCrumb} = useBreadCrumbs()

export const PERIOD_LOCK: PanelContent = {
    componentName: 'PeriodLock',
    component: PeriodLockView,
    meta: {requiresOrg: true}
}
registerRoute(PERIOD_LOCK)
const period_lock_label = 'Periodelåsing'
const period_lock_icon = 'i-ph-lock-fill'
registerNavigationCommand({
    route: PERIOD_LOCK,
    label: period_lock_label,
    icon: period_lock_icon
})
registerNavigationEntry(NavGroup.MISC, {
    title: period_lock_label,
    key: 'period-lock',
    icon: period_lock_icon,
    target: PERIOD_LOCK,
    sortOrder: 6
})
buildSimpleCrumb(PERIOD_LOCK, period_lock_label, period_lock_icon)